module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_search_input-8772db556aa6afb7d3a4954f70030fb0.svg";